export const GET_WEBHOOKS = 'src/pages/parcels/GET_WEBHOOKS';
export const GET_WEBHOOKS_SUCCESS = 'src/pages/parcels/GET_WEBHOOKS_SUCCESS';
export const GET_WEBHOOKS_FAILED = 'src/pages/parcels/GET_WEBHOOKS_FAILED';

export const UPDATE_WEBHOOKS = 'src/pages/parcels/UPDATE_WEBHOOKS';
export const UPDATE_WEBHOOKS_SUCCESS =
  'src/pages/parcels/UPDATE_WEBHOOKS_SUCCESS';
export const UPDATE_WEBHOOKS_FAILED = 'src/pages/parcels/UPDATE_WEBHOOKS_FAILED';

export const CREATE_WEBHOOKS = 'src/pages/parcels/CREATE_WEBHOOKS';
export const CREATE_WEBHOOKS_SUCCESS =
  'src/pages/parcels/CREATE_WEBHOOKS_SUCCESS';
export const CREATE_WEBHOOKS_FAILED = 'src/pages/parcels/CREATE_WEBHOOKS_FAILED';

export const DELETE_WEBHOOKS = 'src/pages/parcels/DELETE_WEBHOOKS';
export const DELETE_WEBHOOKS_SUCCESS =
  'src/pages/parcels/DELETE_WEBHOOKS_SUCCESS';
export const DELETE_WEBHOOKS_FAILED = 'src/pages/parcels/DELETE_WEBHOOKS_FAILED';